{
 "name": "0_plant_flower_4",
 "bin": "0_plant_flower_4.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_flower4", "parent": 1, "t": [0.9701741,-1.62216,0], "q": [0.03831506,-0.9929294,0.04560658,0.1026804], "s": [0.8,0.8,0.8]},
  {"name": "", "parent": 10, "t": [1.263775,6.168199,-0.2544198], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Capsule02", "parent": 10, "t": [1.263773,-1.343757,-0.2544184], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]},
  {"name": "Capsule01", "parent": 10, "t": [1.263773,-1.343757,-0.2544184], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 78, "posOffset": 0, "nrmOffset": 936, "uvOffset": 1872, "material": "0_plant_flower4", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_4.png"},
  {"node": 13, "vertexCount": 78, "posOffset": 2496, "nrmOffset": 3432, "uvOffset": 4368, "material": "0_plant_flower4", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_4.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 4992},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 18992},
  {"name": "idle", "duration": 0.8, "fps": 30, "frames": 25, "offset": 74992},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 88992}
 ]
}
